export const STAR_RATING = "Star Rating";
export const TEXT_AREA = "Text Area";
export const LABEL = "Label";
export const FILE_UPLOAD = "Attachments";